import React, { useState } from 'react';
import { useWidgetContext } from 'widgets/WidgetContext';

import './CorporateActionsWidget.scss';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { useCorporateActionsPortfolioRequirements } from 'widgets/corpActions/widget/hooks';
import CorporateActionsToolbar from 'widgets/corpActions/widget/toolbar/CorporateActionsToolbar';
import { CorporateActionsWidgetContent } from 'widgets/corpActions/widget/CorporateActionsWidgetContent';
import { GridApi } from '@instinet-analytics/semantic-ui-components';

export function CorporateActionsWidget() {
    const { widgetKey } = useWidgetContext();

    const [gridApi, setGridApi] = useState<GridApi | undefined>();

    useWidgetStream();

    const requirements = useCorporateActionsPortfolioRequirements();

    return (
        <div className="CorporateActionsWidget" data-widget-id={widgetKey}>
            <CorporateActionsToolbar gridApi={gridApi} />
            {requirements.meetsRequirements && (
                <CorporateActionsWidgetContent onGridApiSet={setGridApi} />
            )}
        </div>
    );
}
